import { Link } from "react-router-dom";
import { FeedbackTutorialViewModel } from "../../scoreReport/scoreReportApiSlice";

export interface Props {
	className: string;
	heading: string;
	tutorials: FeedbackTutorialViewModel[];
}

export function TraitTutorials(props: Props) {
	if (!props.tutorials) return null;

	return (
		<section>
			<h3 className={props.className}>{props.heading}</h3>
			<ul className="ps-5">
				{props.tutorials.map((feedback, index) => {
					return (
						<li key={index} className="list-disc list-outside">
							<Link to={`/lessons/${feedback.codeName}`}>{feedback.name}</Link>
						</li>
					);
				})}
			</ul>
		</section>
	);
}
